import { createAsyncAction } from "../utils"

import { api as externalApi } from "../../services/api"
import types from "./types"

const api = externalApi()

export const fetchHomepage = createAsyncAction(types.FETCH_HOMEPAGE, api.home.getHomepage)
